import { StylesConfig } from 'react-select'

import { MultiSelectValue } from '../MultiSelect'

export const customStyles = (): StylesConfig<MultiSelectValue> => {
  return {
    menu: (defaultStyles) => {
      return {
        ...defaultStyles,
        minWidth: '450px',
      }
    },
    control: (defaultStyles, state) => {
      return {
        ...defaultStyles,
        height: 'auto',
        minHeight: '40px',
        flexWrap: 'wrap',
      }
    },
    valueContainer: (defaultStyles) => {
      return {
        ...defaultStyles,
        flexWrap: 'wrap',
        gap: '4px',
      }
    },
  }
}
